module.exports = __webpack_public_path__ + "img/MR.9b3e1e81.png";